import { render, staticRenderFns } from "./SpecializationMajor.vue?vue&type=template&id=3c8be778&"
import script from "./SpecializationMajor.vue?vue&type=script&lang=js&"
export * from "./SpecializationMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports